import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerScanCigaretteCaseInfoListDataApi(data) {
  return request({
    url: "web/appConsumerScanCigaretteCaseInfo/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadAppConsumerScanCigaretteCaseInfoExportDataApi(data) {
  return request({
    url: "web/appConsumerScanCigaretteCaseInfo/exportData",
    method: "post",
    data
  });
}

// 根据消费者ID获取数据
export function listSelectDataByConsumerIdApi(data) {
  return request({
    url: "web/appConsumerScanCigaretteCaseInfo/listSelectDataByConsumerId",
    method: "post",
    data
  });
}